const ko = {
    all: '모두',
    mainBranch: '메인 브랜치',
    branchVersion: '지점 버전',
    recordList: '레코드 목록',
    add: '추가',
    versionNum: '버전 번호',
    updateDesc: '설명 업데이트',
    file: '파일(.apk)',
    downTips: '다운로드 중입니다. 잠시만 기다려 주세요. ',
    downFailError: '다운로드 실패, {{오류}}',
    addAppRecord: 'APP 릴리스 레코드 추가',
    plFillInfo: '정보를 모두 입력해 주세요!',
    addSuccess:'성공적으로 추가되었습니다',
    delApk: 'apk 삭제',
};

export default ko;